import { ISymbol } from "../../models/ISymbol";

export class SymbolState {
  symbolsList: ISymbol[] = [];
}
